import isNil from "lodash/isNil";
import BridgeV2 from "@akulaku/web-bridge";
import { Logger } from "@al/base-lib";

import { tracker } from "~/common/tracker";

import __load__FB from "./helpers/__load__FB";
import __get__short__link from "./helpers/__get__short__link";

const share = async (
  { shareContentUrl, shareContentTitle, shareImageUrl, shareContentDescription, sharePageId, sharePageName, callback },
  channelId
) => {
  const shareParam = {
    shareContentDescription: shareContentDescription,
    shareContentTitle: shareContentTitle,
    shareContentUrl: await __get__short__link(shareContentUrl),
    shareImageUrl: shareImageUrl,
    sharePageId: sharePageId || tracker.getPageConfig()?.sa?.page_id,
    sharePageName: sharePageName || tracker.getPageConfig()?.sa?.page_name,
  };
  Logger.info("shareParam", channelId, {
    ...shareParam,
    origUrl: shareContentUrl,
  });

  // 是否指定了分享渠道
  const __declared__channel = !isNil(channelId) && channelId !== -1;

  // 若存在 channelId 则优先按 channelId 分享
  if (__declared__channel) {
    if (
      BridgeV2.shareByType(
        {
          platformType: channelId,
          ...shareParam,
        },
        callback
      )
    ) {
      return;
    }
  } else {
    // 优先尝试分享到全平台
    BridgeV2.shareToAllPlatForm(shareParam, callback);
  }

  // 若不支持上述 App jsBridge，尝试调用 web 端 FB 分享
  /* if (!__declared__channel || channelId === 5) {
      const FB = await __load__FB()

      setTimeout(() => {
        console.log('尝试调用 FB jsapi 分享方法')

        run(
          FB,
          'ui',
          {
            method: 'share',
            href: shareParam.url,
            quote: shareParam.description
          },
          shareParam.callback
        )
      })
    } */
};

export default share;
